import { useState } from 'react'
import type { BlockEditorVariableValues } from '@sequencehq/core-components'
import type { QuoteVariableType } from '@sequencehq/quote-content'
import { dequal } from 'dequal'
import { useCubeContext } from 'Cube/communication/internal/cube.domain.context'
import { getVariableValue } from '../utils/quoteVariables'
import { quoteVariableLabel } from '../utils/quoteVariables.constants'

/**
 * The current value of every quote variable. They're worked out from the whole
 * quote, so any change to the data behind one, the customer's address included,
 * reaches the editor. Each change updates every variable in the document, so a
 * new object is only returned when a value actually changes.
 */
export const useQuoteVariableValues = (): BlockEditorVariableValues => {
  const cubeContext = useCubeContext()
  const variableValue = getVariableValue(
    cubeContext.queries,
    cubeContext.queries.rawData.data
  )
  const values = Object.fromEntries(
    (Object.keys(quoteVariableLabel) as QuoteVariableType[]).map(
      variableType => [variableType, variableValue(variableType)]
    )
  )

  const [latestValues, setLatestValues] = useState(values)

  if (!dequal(latestValues, values)) {
    setLatestValues(values)
  }

  return latestValues
}
